import { MutationTree } from 'vuex';
import * as TYPES from './types';
import { IState } from './state';
import { Message } from 'element-ui';
import Vue from 'vue';

export const mutations: MutationTree<any> = {
  // 获取岗位下拉
  [TYPES.MAP_STATION.REQUEST](state: IState) {
    state.mapStation.loading = true;
  },
  [TYPES.MAP_STATION.SUCCESS](state: IState, payload) {
    const data = payload.res.Data;
    state.mapStation.loading = false;
    state.mapStation.infos = data;
  },
  [TYPES.MAP_STATION.FAILED](state: IState) {
    state.mapStation.infos = [];
    state.mapStation.loading = false;
  },

  // 获取子系统下拉
  [TYPES.MAP_SYS.REQUEST](state: IState) {
    state.mapSys.loading = true;
  },
  [TYPES.MAP_SYS.SUCCESS](state: IState, payload) {
    const data = payload.res.Data;
    state.mapSys.loading = false;
    state.mapSys.infos = data;
  },
  [TYPES.MAP_SYS.FAILED](state: IState) {
    state.mapSys.infos = [];
    state.mapSys.loading = false;
  },

  // 获取课程信息
  [TYPES.MAP_COURSE_LIST.REQUEST](state: IState) {
    state.mapCourseList.loading = true;
  },
  [TYPES.MAP_COURSE_LIST.SUCCESS](state: IState, payload) {
    const data = payload.res.Data;
    state.mapCourseList.loading = false;
    state.mapCourseList.courseSummry = data.CourseSummry;
    state.mapCourseList.infos = data.List;
  },
  [TYPES.MAP_COURSE_LIST.FAILED](state: IState) {
    state.mapCourseList.infos = [];
    state.mapCourseList.courseSummry = {};
    state.mapCourseList.loading = false;
  },
  // 获取课程状态
  [TYPES.MAP_COURSE_STATUS.REQUEST](state: IState) {
    state.mapCourseStatus.loading = true;
  },
  [TYPES.MAP_COURSE_STATUS.SUCCESS](state: IState, payload) {
    const data = payload.res.Data;
    state.mapCourseStatus.loading = false;

    state.mapCourseStatus.infos = data;
  },
  [TYPES.MAP_COURSE_STATUS.FAILED](state: IState) {
    state.mapCourseStatus.infos = [];
    state.mapCourseStatus.loading = false;
  },

  // 获取用户默认配置
  [TYPES.MAP_USER_SETTING.REQUEST](state: IState) {
    state.mapUserSetting.loading = true;
  },
  [TYPES.MAP_USER_SETTING.SUCCESS](state: IState, payload) {
    const data = payload.res.Data;
    state.mapUserSetting.loading = false;
    state.mapUserSetting.infos = data;
  },
  [TYPES.MAP_USER_SETTING.FAILED](state: IState) {
    state.mapUserSetting.infos = [];
    state.mapUserSetting.loading = false;
  },

  // 保存用户默认配置
  [TYPES.SET_MAP_USER_SETTING.REQUEST](state: IState) {
    state.setMapUserSetting.loading = true;
  },
  [TYPES.SET_MAP_USER_SETTING.SUCCESS](state: IState, payload) {
    const data = payload.res.Data;
    state.setMapUserSetting.loading = false;
    state.setMapUserSetting.infos = data;
  },
  [TYPES.SET_MAP_USER_SETTING.FAILED](state: IState) {
    state.setMapUserSetting.infos = [];
    state.setMapUserSetting.loading = false;
  },

    // 导入
    [TYPES.SET_MAP_IMPORT.REQUEST](state: IState) {
      state.studyMapimport.loading = true;
    },
    [TYPES.SET_MAP_IMPORT.SUCCESS](state: IState, payload) {
      const data = payload.res.Data;
      state.studyMapimport.loading = false;
      state.studyMapimport.infos = data;
    },
    [TYPES.SET_MAP_IMPORT.FAILED](state: IState) {
      state.studyMapimport.infos = [];
      state.studyMapimport.loading = false;
  }
};
